import { graphql } from 'src/gql';

import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import { useFlagsAndLoadingState } from '../contexts/launch-darkly-flags-ready-context';

const ViewerActiveHouseholdIdQuery = graphql(/* GraphQL */ `
  query ViewerActiveHouseholdId {
    currentUser {
      user {
        id
        activeHousehold {
          id
        }
      }
    }
  }
`);

export type UseActiveHouseholdIdResult = {
  readonly activeHouseholdId: string | null;
  readonly canQuery: boolean;
};

export function useActiveHouseholdId(): UseActiveHouseholdIdResult {
  const { flagsReady } = useFlagsAndLoadingState();
  const skip = !flagsReady;

  const { data, loading } = useQueryWithErrorLogging(ViewerActiveHouseholdIdQuery, { skip });

  const resolved = !skip && !loading;

  return {
    activeHouseholdId: resolved ? (data?.currentUser.user?.activeHousehold?.id ?? null) : null,
    canQuery: resolved,
  };
}
